export function formatCurrency(cents: number): string {
  const dollars = cents / 100;

  return `$${dollars.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}`;
}

export function formatDollarAmount(dollars: number): string {
  return `$${dollars.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

/**
 * For date-only strings (e.g. '2025-03-20'), appends 'T00:00:00' to avoid
 * timezone-offset shifts. Full ISO timestamps are parsed as-is.
 */
export function formatDate(
  dateStr: string,
  style: 'short' | 'long' = 'short',
): string {
  const isDateOnly = !dateStr.includes('T');
  const date = new Date(isDateOnly ? dateStr + 'T00:00:00' : dateStr);

  return date.toLocaleDateString('en-US', {
    month: style,
    day: 'numeric',
    year: 'numeric',
  });
}

export function formatCompactNumber(value: number): string {
  if (value >= 1_000_000) {
    const millions = value / 1_000_000;

    return `${millions % 1 === 0 ? millions.toFixed(0) : millions.toFixed(1)}M`;
  }

  if (value >= 1_000) {
    const thousands = value / 1_000;

    return `${thousands % 1 === 0 ? thousands.toFixed(0) : thousands.toFixed(1)}K`;
  }

  return value.toLocaleString();
}
